import { AxiosRequestConfig } from 'axios';
import { ITable } from '../ApiManager';
import { SearchAnimalController } from '../DexieDB/modules/animals/useCases/SearchAnimalUseCase/SearchAnimalController';

export async function Pagination(
  table: ITable,
  url: string,
  type: string,
  config?: AxiosRequestConfig,
) {
  const propriedade_id = config?.headers.propriedade_id;

  const result = await SearchAnimalController({
    table,
    config,
    propriedade_id,
  });

  return { animais: result };
}
